var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 180,
    viewBox: "0 0 324 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1355_10169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 7.51624C88.0318 22.9362 55.2953 72.218 68.3806 117.59C81.4658 162.962 135.418 187.243 188.885 171.823C242.353 156.403 275.09 107.122 262.004 61.7495C248.919 16.3773 194.967 -7.90375 141.5 7.51624Z",
    fill: "#B6E3FF",
    stroke: "#B6E3FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3214 16.2485C32.6686 25.3771 13.2886 54.552 21.035 81.4123C28.7815 108.273 60.721 122.647 92.3739 113.518C124.027 104.39 143.407 75.2149 135.66 48.3546C127.914 21.4942 95.9743 7.11985 64.3214 16.2485Z",
    fill: "#B6E3FF",
    stroke: "#B6E3FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6619 142.535C33.529 144.015 30.3863 148.746 31.6425 153.102C32.8987 157.457 38.078 159.788 43.2109 158.308C48.3438 156.828 51.4865 152.097 50.2304 147.741C48.9742 143.385 43.7948 141.054 38.6619 142.535Z",
    fill: "#B6E3FF",
    stroke: "#B6E3FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.25 74.1422C218.579 80.6803 204.699 101.576 210.247 120.814C215.796 140.051 238.671 150.347 261.341 143.808C284.012 137.27 297.892 116.375 292.344 97.1371C286.796 77.8993 263.92 67.6041 241.25 74.1422Z",
    fill: "#B6E3FF",
    stroke: "#B6E3FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 98.67L313.28 96.08C314.28 95.72 314.28 94.31 313.28 93.95L306 91.36C304.45 90.81 303.23 89.59 302.67 88.03L300.08 80.75C299.72 79.75 298.31 79.75 297.95 80.75L295.36 88.03C294.81 89.58 293.59 90.8 292.03 91.36L284.75 93.95C283.75 94.31 283.75 95.72 284.75 96.08L292.03 98.67C293.58 99.22 294.8 100.44 295.36 102L297.95 109.28C298.31 110.28 299.72 110.28 300.08 109.28L302.67 102C303.22 100.45 304.44 99.23 306 98.67Z",
    fill: "#00A8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4744 44.3257L33.1107 43.032C33.6102 42.8521 33.6102 42.1479 33.1107 41.968L29.4744 40.6743C28.7002 40.3996 28.0907 39.7902 27.811 39.011L26.5173 35.3746C26.3375 34.8751 25.6332 34.8751 25.4534 35.3746L24.1597 39.011C23.885 39.7852 23.2755 40.3946 22.4963 40.6743L18.86 41.968C18.3605 42.1479 18.3605 42.8521 18.86 43.032L22.4963 44.3257C23.2705 44.6004 23.88 45.2098 24.1597 45.989L25.4534 49.6254C25.6332 50.1249 26.3375 50.1249 26.5173 49.6254L27.811 45.989C28.0857 45.2148 28.6952 44.6054 29.4744 44.3257Z",
    fill: "#00A8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4744 59.3257L18.1107 58.032C18.6102 57.8521 18.6102 57.1479 18.1107 56.968L14.4744 55.6743C13.7002 55.3996 13.0907 54.7902 12.811 54.011L11.5173 50.3746C11.3375 49.8751 10.6332 49.8751 10.4534 50.3746L9.15969 54.011C8.88496 54.7852 8.27553 55.3946 7.49631 55.6743L3.85998 56.968C3.36048 57.1479 3.36048 57.8521 3.85998 58.032L7.49631 59.3257C8.27053 59.6004 8.87997 60.2098 9.15969 60.989L10.4534 64.6254C10.6332 65.1249 11.3375 65.1249 11.5173 64.6254L12.811 60.989C13.0857 60.2148 13.6952 59.6054 14.4744 59.3257Z",
    fill: "#00A8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.178 118.857V148.493C186.178 149.621 184.967 150.355 183.959 149.824L159.702 137.06C159.261 136.823 158.729 136.823 158.298 137.06L134.042 149.824C133.034 150.355 131.822 149.621 131.822 148.493V119.658",
    fill: "#00A8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.178 118.857V148.493C186.178 149.621 184.967 150.355 183.959 149.824L159.702 137.06C159.261 136.823 158.729 136.823 158.298 137.06L134.042 149.824C133.034 150.355 131.822 149.621 131.822 148.493V119.658",
    stroke: "#02080E",
    strokeWidth: 1.64384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.959 76.0276C209.959 84.6723 200.277 90.7891 196.426 97.7523C192.565 104.727 191.625 116.407 184.479 120.436C177.345 124.465 167.561 119.342 159 119.342C150.439 119.342 140.428 124.601 133.419 120.436C126.409 116.272 125.741 104.817 121.607 97.6168C117.474 90.4054 108.041 84.6723 108.041 76.0276C108.041 67.3829 117.723 61.2661 121.573 54.3029C125.435 47.3285 126.375 35.6141 133.419 31.619C140.462 27.6239 150.337 32.7137 158.898 32.7137C167.459 32.7137 177.572 27.4208 184.479 31.619C191.387 35.8172 192.157 47.272 196.291 54.4722C200.424 61.6837 209.959 67.3829 209.959 76.0276V76.0276Z",
    fill: "#B6E3FF",
    stroke: "#02080E",
    strokeWidth: 1.64384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.192 110.375C178.061 110.375 193.358 95.1308 193.358 76.3263C193.358 57.5219 178.061 42.2778 159.192 42.2778C140.324 42.2778 125.027 57.5219 125.027 76.3263C125.027 95.1308 140.324 110.375 159.192 110.375Z",
    fill: "white",
    stroke: "#02080E",
    strokeWidth: 1.64384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.635 60.8482L163.986 69.6442C164.092 69.8549 164.286 69.9954 164.515 70.0305L174.248 71.4438C174.83 71.5316 175.059 72.2339 174.636 72.6377L167.589 79.4849C167.422 79.643 167.351 79.88 167.387 80.1082L169.051 89.7734C169.148 90.344 168.549 90.7829 168.03 90.5108L159.318 85.9459C159.115 85.8406 158.869 85.8406 158.666 85.9459L149.954 90.5108C149.435 90.7829 148.836 90.344 148.933 89.7734L150.597 80.1082C150.633 79.88 150.562 79.6517 150.395 79.4849L143.357 72.6289C142.943 72.2251 143.172 71.5141 143.744 71.4351L153.478 70.0217C153.707 69.9866 153.909 69.8461 154.006 69.6355L158.367 60.8482C158.622 60.3302 159.371 60.3302 159.626 60.8482H159.635Z",
    stroke: "#02080E",
    strokeWidth: 1.64384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1355_10169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 324,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataBadge);
export default __webpack_public_path__ + "static/media/NoDataBadge.a6279e75ae1a8b76fe819f738ccf4d6c.svg";
export { ForwardRef as ReactComponent };